<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
// import "chartjs-plugin-labels";
// eslint-disable-next-line no-unused-vars
import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";

export default {
  name: "OdilBar",
  extends: Bar,
  mixins: [reactiveProp],
  /*props: [""],
  props: {
    chartdata: { type: Object, default: null },
    options: { type: Object, default: null }
  },*/
  data: () => ({
    /*chartdata: {
      labels: ["DZH", "opta data", "severins", "acriba"],
      datasets: [
        {
          label: "Abrechnung",
          backgroundColor: ["#bf1616", "#1c9bbb", "#fea201", "#0e4b7e"],
          data: [40, 60, 20, 5, 0]
        }
      ]
    },*/
    options: {
      plugins: {
        datalabels: {
          formatter: value => {
            return value.toLocaleString("de-DE", {
              style: "currency",
              currency: "EUR"
            });
          },
          rende: "value",
          color: "black",
          textAlign: "start",
          font: {
            weight: "bold",
            size: 12
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false,

      legend: {
        display: false,
        fontSize: 14
      },
      tooltips: {
        // enabled: true,
        // mode: "single",
        callbacks: {
          // eslint-disable-next-line no-unused-vars
          label: function(tooltipItems, data) {
            return tooltipItems.yLabel.toLocaleString("de-DE", {
              style: "currency",
              currency: "EUR"
            });
          }
        }
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              // eslint-disable-next-line no-unused-vars
              callback: function(value) {
                return value.toLocaleString("de-DE", {
                  style: "currency",
                  currency: "EUR"
                });
              }
            },
            gridLines: {
              display: true
            }
          }
        ],
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ]
      }
      // plugins: {
      //   labels: [
      //     {
      //       render: "label",
      //       fontColor: "#000",
      //       fontSize: 14,
      //       // arc: true,
      //       // fontStyle: "bold",
      //       position: "outside",
      //       // outsidePadding: 4,
      //       textMargin: 5
      //     },
      //     {
      //       render: "percentage",
      //       fontColor: "#fff",
      //       textMargin: -25,

      //       fontSize: 14,
      //       position: "outside",
      //       outsidePadding: 5
      //       // precision: 2
      //     }
      //     // render: "label"

      //     // render: "value",
      //     // fontColor: "#fff"
      //   ]
      // }
    }
  }),
  mounted() {
    // console.log("renderBar ");
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
};
</script>
